<template>
  <div class="container mt-3">
    <div class="jumbotron">
      <form @submit.prevent="add" autocomplete="off">
        <div class="form-group">
          <label for="projectTitle">Titolo Progetto</label>
          <input required v-model="project.title" type="text" class="form-control" id="projectTitle" placeholder="Titolo">
        </div>
        <div class="form-group">
          <label for="projectDescription">Descrizione</label>
          <div id="editor">
            <quill-editor id="projectDescription" class="form-control" :config="editorOption" v-model="project.description"></quill-editor>
          </div>
        </div>
        <div class="form-group">
          <label for="projectTldr">Riassunto</label>
          <textarea v-model="project.tldr" class="form-control" id="projectTldr" placeholder="TLDR"></textarea>
        </div>
        <!-- Upload immagine profilo -->
        <div v-if="crop1" class="form-group">
          <label for="projectImage">Immagine profilo</label>
          <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text">Upload</span>
            </div>
            <div class="custom-file">
              <input type="file" v-on:change="onFileChange1" class="custom-file-input" id="inputGroupFile01">
              <label class="custom-file-label" for="inputGroupFile01">Scegli il file</label>
            </div>
          </div>
        </div>
         <div v-else class="form-group">
           <input type="button" class="btn btn-primary" @click="cropImage1" value="Ridimensiona">
          <vue-cropper :aspectRatio="1" :cropBoxResizable="false" :zoomable="false" :guides="true" :view-mode="2" drag-mode="move" ref="cropper" :src="image" alt="Source Image">
          </vue-cropper>
        </div>
        <!-- Fine immagine profilo -->
        <!-- Upload Slideshow -->
        <div v-if="crop2" class="form-group">
          <label for="projectImage">Slideshow</label>
          <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text">Upload</span>
            </div>
            <div class="custom-file">
              <input type="file" v-on:change="onFileChange" class="custom-file-input" id="inputGroupFile02">
              <label class="custom-file-label" for="inputGroupFile02">Scegli il file</label>
            </div>
          </div>
        </div>
        <div v-else class="form-group">
          <input type="button" class="btn btn-primary" @click="cropImage2" value="Ridimensiona">
          <vue-cropper :aspectRatio="1.777777" :cropBoxResizable="false" :zoomable="true" :guides="true" :view-mode="2" drag-mode="move" ref="cropperz" :src="image" alt="Source Image">
          </vue-cropper>
        </div>
        <!-- Upload slideshow -->
        <div class="form-group">
          <label for="projectTeam">Assegna un team</label>
          <input v-model="project.teamName" required list="teamList" aria-describedby="teamHelpMsg" id="projectTeam" class="form-control"/>
          <small id="teamHelpMsg" class="form-text text-muted">Clicca due volte per mostrare la lista dei team.</small>
          <datalist id="teamList">
            <option v-for="team in teams" :value="team.name"/>
          </datalist>
          <p class="text-info">Non trovi il team che cerchi? <button type="button" class="btn btn-link" data-toggle="modal" @click="startUserListener" data-target="#newTeamModal">Crealo!</button></p>

          <!-- Modal -->
          <div class="modal fade" id="newTeamModal" tabindex="-1" role="dialog" aria-labelledby="newTeamModalTitle" aria-hidden="true">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <form @submit.prevent="createNewTeam">
                  <div class="modal-header">
                    <h5 class="modal-title" id="newTeamModalTitle">Crea un nuovo team</h5>
                    <button @click="closeModal" type="button" class="close" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="form-group">
                      <label for="teamName">Nome del team</label>
                      <input required v-model="newTeam.name" type="text" class="form-control" id="teamName" placeholder="Nome">
                    </div>
                     <div class="form-group">
                      <label for="teamUserSelect">Utenti del team</label>
                      <select required v-model="newTeam.users" aria-describedby="userSelectHelp" multiple class="form-control" id="teamUserSelect">
                        <option v-for="user in userList" v-bind:value="user.email">{{ user.name }} - {{ user.email }}</option>
                      </select>
                      <small id="userSelectHelp" class="form-text text-muted">Seleziona piu' utenti tenendo premuto CTRL o SHIFT per selezionare una sequenza</small>
                    </div>
                    <div class="form-group">
                      <label for="teamBalance">Fiorini iniziali</label>
                      <input v-model="newTeam.balance" type="number" class="form-control" id="teamBalance" placeholder="Fiorini">
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button @click="closeModal" type="button" class="btn btn-secondary" >Annulla</button>
                    <button type="submit" class="btn btn-primary">Salva</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-6">
            <div class="form-check mb-3">
              <input v-model="project.isPrivate" type="checkbox" class="form-check-input" id="projectIsPrivate">
              <label class="form-check-label" for="projectIsPrivate">Privato</label>
              <small id="projectPrivateHelp" class="form-text text-muted">I progetti privati non possono essere in evidenza</small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-check mb-3">
              <input v-model="project.isFeatured" aria-describedby="projectFeaturedHelp" type="checkbox" class="form-check-input" id="projectIsFeatured">
              <label class="form-check-label" for="projectIsFeatured">In Evidenza</label>
              <small id="projectFeaturedHelp" class="form-text text-muted">Soltanto i primi 3 progetti saranno messi in evidenza</small>
            </div>
          </div>
        </div>
        <button type="submit" class="btn btn-primary">Submit</button>
      </form>
    </div>
  </div>
</template>

<script>
import { firebase, database, storage } from "@/firebase";
import { getCurrentUser, permissions } from "@/helpers";
import router from "@/router";
import { quillEditor} from "vue-quill-editor"
import VueCropper from "vue-cropperjs"

export default {
  name: 'AdminProjectAdd',
  data() {
    return {
      image: '',
      showCropper: true,
      crop1: true,
      crop2: true,
      cropImg: '',
      editorOption: {
        theme: 'snow'
      },
      userListener: null,
      slideshow: [],
      teams: [],
      teamRegex: '',
      project: {
        title: '',
        description: '',
        tldr: '',
        isPrivate: false,
        isFeatured: false,
        teamName: '',
        team: ''
      },
      userList: [],
      newTeam: {
        name: '',
        users: [],
        projects: [],
        balance: 0,
      }
    };
  },
  components:{
    quillEditor,
    VueCropper,
  },
  created() {

    database.collection('Teams')
      .onSnapshot(querySnapshot => {
        this.teams = []
        querySnapshot.forEach(teamDoc => {
          this.teams.push({
            name: teamDoc.data().name,
            id: teamDoc.id
          })
        })
      })
  },
  methods: {

    onFileChange1: function(e) {
      this.crop1 = false
      let reader = new FileReader
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      reader.onload = (event) => {
        this.image = event.target.result;
        // rebuild cropperjs with the updated source
        this.$refs.cropper.replace(event.target.result);
      };
      reader.readAsDataURL(files[0]);
      //this.image = files[0]
      //this.createImage(files[0]);
    },
    onFileChange: function(e) {
      if(this.slidecounter != 0) this.crop2 = !this.crop2
      let reader = new FileReader
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length)
        return;
      reader.onload = (event) => {
        this.image = event.target.result;
        // rebuild cropperjs with the updated source
        this.$refs.cropperz.replace(event.target.result);
      };
      reader.readAsDataURL(files[0]);
      console.log(this.image)
      //this.createImage(files[0]);
    },
    cropImage1() {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      this.crop1 = true
      console.log(this.cropImg)
    },
    cropImage2(profile) {
      // get image data for post processing, e.g. upload or setting image src
      if(this.slidecounter != 0){
        this.crop2 = !this.crop2
        console.log("slideshow")
        profile = false
        this.slidecounter--
        this.slideshow.push(this.$refs.cropperz.getCroppedCanvas().toDataURL())
      }
      console.log(this.slideshow)
    },
    validateTeamList: function() {
      let teamInput = document.querySelector('#projectTeam')
      let selectedTeam = teamInput.value
      let teamList = teamInput.list
      let teamFound = false

      this.teams.forEach(team => {
        if(team.name == selectedTeam){
          teamFound = true;
        }
      })

      if(!teamFound) teamInput.setCustomValidity('Seleziona un team presente nell\' elenco')
      return teamFound;
    },
    add: async function() {
      if (!this.validateTeamList())
        return

      this.project.creationDate = new Date()
      this.project.lastUpdate = new Date()

      // Se l'utente ha selezionato entrambe le checkbox (privato, featured)
      // setta featured a false
      if (this.project.isFeatured && this.project.isPrivate) this.project.isFeatured = false;

      // Taglio il riassunto del progetto
      if (this.project.tldr.length > 50) {
        this.project.tldr = this.project.tldr.slice(0, 47)
        this.project.tldr += '...'
      }
      
      // Add team reference to project
      await database.collection('Teams')
        .where('name', '==', this.project.teamName)
        .get().then(querySnapshot => {
          querySnapshot.forEach(async teamDoc => {
            this.project.team = await database.collection('Teams')
              .doc(teamDoc.id)
          })
        })

      // Delete project teamName field
      delete this.project.teamName

      // Upload project to database
      let newProjectRef = await database.collection('Projects')
        .add(this.project)

      // Add project reference to team
      await this.project.team.get().then(teamDoc => {
        let teamProjects = teamDoc.data().projects
        teamProjects.push(newProjectRef)
        this.project.team.update({
          projects: teamProjects
        })
      })

      // Create a folder in storage for images
      await storage.child("Projects/" + newProjectRef.id + "/profilo").putString(this.cropImg, 'data_url')
      console.log(this.slideshow)
      for(let i = 1; i <= 3; i++){
        await storage.child("Projects/" + newProjectRef.id + "/Slideshow/"+ (i - 1).toString()).putString(this.slideshow[i-1], 'data_url')
      }
      // Redirect to project list
      router.push('/admin/project/list')
    },
    startUserListener: function() {
      this.userListener = database.collection('Users')
        .onSnapshot(querySnapshot => {
          this.userList = []
          querySnapshot.forEach(userDoc => {
            this.userList.push(userDoc.data())
          })
        })
      console.log('Started listening for users')
    },
    createNewTeam: async function() {
      // Stop listening for user updates
      this.userListener()

      // Close modal
      $('#newTeamModal').modal('hide')

      // Replace user emails with references
      for (let i in this.newTeam.users) {
        this.newTeam.users[i] = await database.collection('Users')
          .doc(this.newTeam.users[i])
      }

      // Update balance to the_wallet
      let the_wallet = await database.collection('Wallets').doc('the_wallet')

      await the_wallet.get().then(walletDoc => {
        the_wallet.update({
          balance: parseInt(walletDoc.data().balance) - parseInt(this.newTeam.balance)
        })
      })

      // Upload new wallet
      let newWalletRef = await database.collection('Wallets')
        .add({
          balance: parseInt(this.newTeamBalance),
          owner: null
        })

      // Set reference to new team
      this.newTeam.wallet = newWalletRef

      // Upload new team to database
      let newTeamRef = await database.collection('Teams')
        .add(this.newTeam)

      // Add new team reference to new wallet
      newWalletRef.get().then(walletDoc => {
        newWalletRef.update({
          owner: newTeamRef
        })
      })

      //Add team reference to user
      this.newTeam.users.forEach(async user => {
        await user.get().then(async userDoc => {
          let userTeams
          if (!userDoc.data().teams)
            userTeams = []
          else
            userTeams = userDoc.data().teams
          userTeams.push(newTeamRef)
          await user.update({
            teams: userTeams
          })
        })
      })
    },
    closeModal: function() {
      // Stop listening for user updates
      this.userListener()
      $('#newTeamModal').modal('hide')

      this.newTeam.name = ''
      this.newTeam.users = []
      this.newTeam.balance = 0
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/AdminProjectAdd.vue